// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__1_908"};